
import { AlertTriangle } from "lucide-react";

interface ReportedReasonDisplayProps {
  reason: string;
}

const ReportedReasonDisplay = ({ reason }: ReportedReasonDisplayProps) => {
  if (!reason) return null;
  
  return (
    <div className="mt-4 p-3 bg-red-50 border border-red-100 rounded-md">
      <h4 className="text-sm font-medium text-red-800 mb-1 flex items-center">
        <AlertTriangle className="h-4 w-4 mr-1" />
        Report Reason
      </h4>
      <p className="text-sm text-red-700">{reason}</p>
    </div>
  );
};

export default ReportedReasonDisplay;
